import { seoUrlToString } from '@/domain/urls'

/**
 * Returns the most representative form of the current URL to avoid indexation duplication
 */
export const getSrpCanonicalUrl = (url: URL) => {
  /**
   * The canonical url should be the same as the current url without the query parameters
   * It will be everything before the "?" in the URL
   * */
  const canonicalUrl = seoUrlToString(url).split('?')[0]

  return canonicalUrl
}
